import { render, staticRenderFns } from "./TumblrConfiguration.vue?vue&type=template&id=1dcafdc5"
import script from "./TumblrConfiguration.vue?vue&type=script&lang=js"
export * from "./TumblrConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports